import React, { Component, Fragment } from 'react';
import autoBind from 'react-autobind';

import Circle from '../sys/Circle.jsx'

import api from '../api/server_api.js'
import store from '../store/store.js'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';

import RaisedButton from 'material-ui/RaisedButton';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';

class Orders extends Component {
  
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { 
      loading: true,
      selectedID: '',
      selectedStatus: '',
      selectedHotel: '',
      orders: []
    };
  }

  componentWillMount(){
    store.clearBackFunction();
    this.loadOrders();
    store.setRefresh(this.loadOrders);
    console.log('orders refresh seted');
  }

  loadOrders() {
    const cb = (data) => {
      if (data) {
        //store.setOrders(data.orders);

        this.setState({loading: false, orders: data.orders});
      }
      else  {        
        console.log('Ошибка сервера при получении списка заказов');
        store.replacePage('/login');
      }
    } //end cb
    this.setState({      
      loading: true,
      selectedID: '',
      selectedStatus: '',
      selectedHotel: '',
      orders: []
    });
    api.getorders(cb);

  }


  handleRowSelection(selrows) {
    let orders = this.state.orders;
    if ( orders[selrows[0]] ) {
      this.setState({
        selectedID: orders[selrows[0]].id,
        selectedStatus: orders[selrows[0]].flag,
        selectedHotel: orders[selrows[0]].otel
      });
    }
    else this.setState({selectedID: ''});
  };

  onNewOrder() {
    store.pushPage('/neworder');
  }

  onDelete() {
    const cb = (data) => {
      if (data) { this.loadOrders() }
      else store.message({title: 'Ошибка', message: 'Не удалось удалить заявку...'});
    }
    let that = this;
    store.confirm({title: 'Внимание!', 
                  message: 'Действительно удалить заявку?', 
                  ok:'ДА', 
                  cancel:'НЕТ'})
      .then(()=>{ api.deleteOrder(that.state.selectedID, cb) })
      .catch();
  }

  showImage() {
    if ( this.state.selectedID === '' ) return;
    const sid = this.state.selectedID;
    const st = this.state.selectedStatus;
    let imageFile;
    if (st === '1' || st === '2' || st === '3') { imageFile = 'confirm.jpg' }
                                            else imageFile = 'order.jpg';
    
    const imageUrl = `${store.host}/${imageFile}?id=${sid}&session=${store.auth.session}`  
    store.showLightBox(imageUrl);
  }

  showVaucher() {
    if ( this.state.selectedID === '' ) return;
    const sid = this.state.selectedID;
    const st = this.state.selectedStatus;
    if (st === '1' || st === '2' || st === '3') {
      const imageUrl = `${store.host}/vaucher.jpg?id=${sid}&session=${store.auth.session}`  
      store.showLightBox(imageUrl);
      }
  }

  render() {
    let {loading, orders, selectedID, selectedStatus, selectedHotel} = this.state;
    if (loading) return (<Circle />)
    else { 

      const turStyle = {width: "30%", whiteSpace: "wrap"};
      const otelStyle = {width: "20%", whiteSpace: "wrap"};
      const statusStyle = {padding: 5};
      const sid = selectedID;
      const sstat = selectedStatus;
      const shotel = selectedHotel;

      const TableRowColumn1 = (props) => {
        let style;
        props.style ? style = props.style : style = {};
        style['paddingLeft'] = 20;
        style['paddingRight'] = 4;
        return <TableRowColumn style={style} {...props} />;
      }

      const TableHeaderColumn1 = (props) => {
        let style;
        props.style ? style = props.style : style = {};
        style['paddingLeft'] = 20;
        style['paddingRight'] = 4;
        return <TableHeaderColumn style={style} {...props} />;
      }

      const tableRow = (row, index) => {
        let nom = row.nom;
        nom === '0' ? nom = 'б/н' : nom = row.ree + ' / ' + nom;

        let summa = row.summa;
        if (summa === '') summa = '0' ;
        let summaop = row.summaop;
        if (summaop === '') summaop = '0' ;
        let statusColor;
        let status = row.flag;
        
        switch (status){
          case '' :
          case '0' : status = 'Неизвестен'; break;
          case '1' : status = 'Подтвержден'; statusColor = '#bb0'; break;
          case '2' : status = 'Оплачен'; statusColor = 'green'; break;
          case '3' : status = 'Предоплата'; statusColor = 'blue'; break;
          case '4' : status = 'Отменен'; statusColor = 'red'; break;
          case '6' : status = 'Новый'; statusColor = 'purple'; break;
        }

        let statusColorStyle = Object.assign({color: statusColor, fontWeight: "bold"}, statusStyle);

        return(
          <TableRow key={index} selected={row.id === sid? true : false}>
            <TableRowColumn1>{nom}</TableRowColumn1>
            <TableRowColumn1>{row.data}</TableRowColumn1>
            <TableRowColumn1 style={turStyle} >{row.tur}</TableRowColumn1>
            <TableRowColumn1 style={otelStyle} >{row.otel}</TableRowColumn1>
            <TableRowColumn1>{summaop}</TableRowColumn1>
            <TableRowColumn1>{summa}</TableRowColumn1>
            <TableRowColumn1 style={statusColorStyle} >{status}</TableRowColumn1>
          </TableRow>
          )
      } // tableRow

      return (
      <Fragment>

      <Toolbar>
        <ToolbarGroup>
          <RaisedButton label="Новая заявка" 
                primary={true} 
                onClick = {this.onNewOrder}
                />
        </ToolbarGroup>
        <ToolbarGroup>

          <RaisedButton label={sstat === '1' || sstat === '2' || sstat === '3' 
                              ? "Открыть подтверждение" : "Открыть заявку"}
                        primary={true} 
                        disabled={ selectedID === '' ? true : false }
                        onClick={this.showImage}
                        />
          <RaisedButton 
            label='Открыть ваучер'
            disabled={
                  (sstat === '1' || sstat === '2' || sstat === '3' )
                  && (sid !== '')
                  && (shotel !=='')
                  ? false : true}
            primary={true} 
            onClick={this.showVaucher}
            />

          <RaisedButton label="Удалить заявку" 
                        secondary={true}
                        disabled={ selectedID === '' || selectedStatus !== '6'? true : false }
                        onClick={this.onDelete}
                        />
        </ToolbarGroup>
      </Toolbar>

      <Table onRowSelection={this.handleRowSelection}
      >
        <TableHeader adjustForCheckbox={false} displaySelectAll={false}>
          <TableRow>
            <TableHeaderColumn1>Номер</TableHeaderColumn1>
            <TableHeaderColumn1>Дата</TableHeaderColumn1>
            <TableHeaderColumn1 style={turStyle} >Тур</TableHeaderColumn1>
            <TableHeaderColumn1 style={otelStyle} >Отель</TableHeaderColumn1>
            <TableHeaderColumn1>Сумма</TableHeaderColumn1>
            <TableHeaderColumn1>К оплате</TableHeaderColumn1>
            <TableHeaderColumn1>Статус</TableHeaderColumn1>
          </TableRow>
        </TableHeader>
        <TableBody 
          displayRowCheckbox={false}
          deselectOnClickaway={false} 
          //showRowHover={true} 
          style={{cursor: "pointer"}}
          >
        {orders.map(tableRow)}

        </TableBody>
      </Table>

      </Fragment>

      )
    }
  }
}

export default Orders;


// WEBPACK FOOTER //
// ./src/pages/Orders.jsx